import useCountries from "../api/useCountries";
import useCountryAcceptance from "../api/useCountryAcceptance";

import React from "react";
import Map from "./Map";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useTheme } from "@mui/material/";

import TechDiff from "./TechDiff";
import Faqs from "./Faqs";
import { GLOBAL_ACCEPTANCE_PATH, FAQS_PATH } from "../routes";

const Content = () => {
  const theme = useTheme();
  const { data: countriesData, error: countriesError } = useCountries();
  const { data: countryData, error: countryError } = useCountryAcceptance();

  if (countriesError || countryError) return <TechDiff />;

  let transformedCountryData = null;

  if (countriesData && countryData) {
    const lookup = {
      en: "en",
      es: "spa", // strangely called spa
    };
    const langDefinition = lookup[theme.lang];
    transformedCountryData = countryData.result.map((m) => ({
      ...m,
      translated_name:
        countriesData.result.find((c) => c.cca3 === m.cca3).translations[
          langDefinition
        ]?.common || m.common_name,
    }));
  }

  return (
    <Router>
      <Switch>
        <Route
          exact
          path="/"
          render={({ location }) => (
            <Redirect
              to={{
                pathname: GLOBAL_ACCEPTANCE_PATH,
                search: location.search,
                hash: location.hash,
              }}
            />
          )}
        />
        <Route
          exact
          path={[GLOBAL_ACCEPTANCE_PATH, `${GLOBAL_ACCEPTANCE_PATH}/`]}
          render={() => {
            return <Map acceptanceData={transformedCountryData} />;
          }}
        />
        <Route exact path={[FAQS_PATH, `${FAQS_PATH}/`]}>
          <Faqs />
        </Route>
        <Route
          exact
          path={["/faqs", "/faqs/"]}
          render={({ location }) => (
            <Redirect
              to={{
                pathname: FAQS_PATH,
                search: location.search,
                hash: location.hash,
              }}
            />
          )}
        />
        <Route exact path="/techdiff">
          <TechDiff />
        </Route>
        <Redirect to={GLOBAL_ACCEPTANCE_PATH} />
      </Switch>
    </Router>
  );
};

export default Content;
